import { PropsWithChildren } from "react";

import { Box, Section } from "@vinomofo/components";

import { ContentBlock } from "./content-block";
import BannerGroupLayout from "./page-section-layouts/banner-group";
import HeroBannerLayout from "./page-section-layouts/full-banner";
import HTMLBannerLayout from "./page-section-layouts/html-banner";
import InlineBannerLayout from "./page-section-layouts/inline-banner";
import styled from "styled-components";

const paddingMap = {
  0: [0],
  1: [10, 15, 20],
  2: [20, 30, 40],
  3: [30, 45, 60],
  4: [40, 60, 80],
};

interface SectionWrapperProps {
  fullWidth?: boolean;
  spaceBefore?: number;
  spaceAfter?: number;
}
export const StyledBox = styled(Box)`
  &:has(> div:empty) {
    padding: 0 !important;
  }
`;
export const StyledSection = styled(Section)`
  &:has(> div:empty) {
    padding: 0 !important;
  }
`;

export const SectionWrapper = ({
  fullWidth,
  spaceBefore,
  spaceAfter,
  children,
}: PropsWithChildren<SectionWrapperProps>): JSX.Element =>
  fullWidth ? (
    <StyledBox pt={paddingMap[spaceBefore]} pb={paddingMap[spaceAfter]}>
      {children}
    </StyledBox>
  ) : (
    <StyledSection pt={paddingMap[spaceBefore]} pb={paddingMap[spaceAfter]}>
      {children}
    </StyledSection>
  );

export const SectionContent = (data) => {
  switch (data.layout) {
    case "Banner Group":
      return BannerGroupLayout.create({ contentBlocks: data.contentBlocks });
    case "Hero Banner":
      return HeroBannerLayout.create({ banner: data.contentBlocks[0] });
    case "HTML Banner":
      return HTMLBannerLayout.create({ banner: data.contentBlocks[0] });
    case "Inline Banner":
      return InlineBannerLayout.create({
        banner: data.contentBlocks[0],
        ...data,
      });
    default:
      return data.contentBlocks.map((contentBlock, index) => {
        return (
          <ContentBlock
            {...contentBlock}
            key={`content-block-${index}`}
            hero={index === 0}
          />
        );
      });
  }
};

const create = (data, index) => {
  const { fullWidth, spaceBefore, spaceAfter } = data;
  const wrapperProps: SectionWrapperProps = {
    fullWidth,
    spaceBefore,
    spaceAfter,
  };

  return (
    <SectionWrapper {...wrapperProps} key={index}>
      <SectionContent {...data} />
    </SectionWrapper>
  );
};

const test = (data): boolean => data._type === "pageSection";

export default { test, create };
